module.exports = "/images/oculus-5.jpg";